import FormInput from '~/components/form-input/FormInput.vue';
import { mapActions, mapState } from 'vuex';
import { post } from '~/utils/adapi';
import { updateUser } from '~/utils/auth';

export default {
  components: {
    'form-input': FormInput,
  },
  data() {
    return {
      password: '',
      newPassword: '',
      confirmNewPassword: '',
      errors: null,
      showMessage: false,
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    errorArray() {
      return Array.isArray(this.errors) ? this.errors : [this.errors];
    },
  },
  methods: {
    ...mapActions('auth', { setApiKey: 'setKey' }),
    handlePasswordChangeResponse(errors, apiKey = null) {
      this.password = '';
      this.newPassword = '';
      this.confirmNewPassword = '';
      this.errors = (!errors || Array.isArray(errors)) ? errors : [errors];
      this.showMessage = true;
      if (apiKey) {
        this.setApiKey(apiKey)
          .then(updateUser);
      }
    },
    changePassword() {
      if (this.confirmNewPassword !== this.newPassword) {
        this.errors = ['The new password and confirmation must match.'];
        this.showMessage = true;
        return;
      }

      this.errors = null;
      this.showMessage = false;
      post('users/change-password', null, {
        password: this.password,
        new_password: this.newPassword,
      })
        .then(apiKey => this.handlePasswordChangeResponse(null, apiKey))
        .catch(errors => this.handlePasswordChangeResponse(errors));
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/account/password/Password.js